import React, { useEffect } from 'react';
import NetworkService from "./util/NetworkService";
import store from "./store/Store";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import MainRouter from "./MainRouterv2";
import { ToastContainer } from 'react-toastify';
import "./styles/Global.scss";
import "react-day-picker/lib/style.css";
import 'react-toastify/dist/ReactToastify.css';
import "@mui/lab/DatePicker";
import "@mui/lab/themeAugmentation";
import Config from './Config';
import { updateFavicon } from './util/favicon';
NetworkService.setupInterceptors(store);


function App() {

    useEffect(() => {
        updateFavicon(Config.DefaultIcon);
    }, []);



    return (
        <Provider store={store}>
            <ToastContainer />
            <Router>
                <MainRouter />
            </Router>
        </Provider>
    );
}

export default App;
